


































































































































import Vue from "vue";
import { Deck } from "../gameplay/Deck";
import { checkHandForWins } from "../gameplay/Winning";
import { Card } from "../models/interfaces";
import {
  Player,
  createMockPlayer,
  createPlayerFromUser
} from "../gameplay/Player";
import Snackbar from "../components/Snackbar.vue";
import Statistics from "../components/Statistics.vue";
import WinningTable from "../components/WinningTable.vue";
import Toplist from "../components/Toplist.vue";

import { cardDealSound, winSound, soundsOff, soundsOn } from "../utils/utils";
import { updateUser } from "../utils/apiRequests";

export default Vue.extend({
  name: "game",
  components: { Snackbar, Statistics, WinningTable, Toplist },
  data: () => ({
    auth: "",
    snackbarText: "",
    snackbarColor: "",
    snackbar: false,
    audio: Object,
    bet: "0",
    dealBtn: {
      text: "Deal"
    },
    loading: true,
    isGameOn: false,
    dealBtnDisabled: false,
    sound: true,
    deck: new Deck(),
    cards: [] as Card[],
    lockedCards: [] as Number[],
    player: Object() as Player
  }),
  methods: {
    lockCard(event: any) {
      if (!this.isGameOn) {
        return;
      }

      const number: number = event.target.value
        ? parseInt(event.target.value)
        : parseInt(event.target.parentElement.value);
      if (this.lockedCards.indexOf(number) === -1) {
        this.lockedCards.push(number);
      } else {
        this.lockedCards = this.lockedCards.filter(x => x !== number);
      }
    },
    async dealChangeCards() {
      this.dealBtnDisabled = true;
      cardDealSound.play();

      this.cards = this.cards.map((card, i) => {
        let changeCardNumber = 1;
        if (this.lockedCards.indexOf(i) === -1) {
          document
            .querySelector(`.card${i + 1}`)
            .classList.add("fadeInRightBig", `card${changeCardNumber}-anim`);
          changeCardNumber++;
          return this.deck.takeCardFromDeck();
        } else {
          return card;
        }
      });
      this.lockedCards = [];
      const possibleWinMultiplier: number = checkHandForWins([...this.cards]);

      // Hand won
      if (possibleWinMultiplier) {
        winSound.play();
        const totalWin: number = this.player.currentBet * possibleWinMultiplier;
        this.player.statistics.biggest_win =
          totalWin > this.player.statistics.biggest_win
            ? totalWin
            : this.player.statistics.biggest_win;

        this.player.payWinning(possibleWinMultiplier);
        this.player.statistics.wins++;
        this.player.statistics.total_games++;
      } else {
        // Hand lost
        this.player.statistics.loses++;
        this.player.statistics.total_games++;
      }

      if (this.player.money > this.player.statistics.money_record) {
        this.player.statistics.money_record = this.player.money;
      }

      const response = await updateUser(this.player, this.auth, this.$router);
      // Show some message or something.
      this.auth = response.auth;
      this.deck = new Deck();
      this.dealBtnDisabled = false;
      this.isGameOn = false;
    },
    dealNewCards() {
      if (this.bet > this.player.money) {
        this.showAndHideSnackbar("No enough money...", "info", 3000);
        return;
      } else if (this.bet < 0) {
        this.showAndHideSnackbar("We don't lend money!", "error", 3000);
        this.bet = 0;
        return;
      }
      cardDealSound.play();
      this.isGameOn = true;
      this.player.currentBet = parseInt(this.bet);
      this.cards = this.deck.take5CardsFromDeck();
      this.animateAllCards();
    },
    showAndHideSnackbar(message: string, color: string, duration: number) {
      this.snackbarText = message;
      this.snackbarColor = color;
      this.snackbar = true;
      setTimeout(() => {
        this.snackbar = false;
      }, duration);
    },
    changeSound() {
      this.sound ? soundsOff() : soundsOn();
      this.sound = !this.sound;
    },
    activateAnimationEndListeners() {
      for (let i = 1; i <= 5; i++) {
        document
          .querySelector(`.card${i}`)
          .addEventListener("animationend", function() {
            document
              .querySelector(`.card${i}`)
              .classList.remove(`card${i}-anim`, `fadeInRightBig`);
          });
      }
    },
    animateAllCards() {
      for (let i = 1; i <= 5; i++) {
        document
          .querySelector(`.card${i}`)
          .classList.add(`fadeInRightBig`, `card${i}-anim`);
      }
    },
    logout() {
      this.$router.replace({
        name: "login",
        params: { loggedIn: "false", msg: 'Thank you for playing!' }
      });
    }
  },
  created() {
    this.cards = this.deck.getCardBack(5);
    // this.player = createMockPlayer();
    if (this.$route.params.user) {
      this.player = createPlayerFromUser(this.$route.params.user);
    }
    this.auth = this.$route.params.auth;
    this.loading = false;
  },
  mounted() {
    this.activateAnimationEndListeners();
  }
});
